import React, {useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button'
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { useSelector, useDispatch } from 'react-redux';
import ReseStoreInfoDialouge from '../store/ReseStoreInfoDialouge';
import { getReseBmsTableDataInit, getReseBmsTableDanfossVersionFirmwareInit, getReseBmsTableEmersonVersionFirmwareInit, getReseBmsTableStatusInit, updateReseBmsTableDataInit } from './redux/actions';
import { Toast } from 'primereact/toast';
import './ReseBms.scss';


const ReseBms = () => {
    const [tableFilters, setTableFilters] = useState(null);
    const [infoDialougeData, setInfoDialougeData] = useState(null);
    const [filterCondition, setFilterCondition] = useState("")
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: "storeId",
        sortOrder: 1
    });
    const reseBmsTableRef = useRef(null);
    const dispatch = useDispatch();

    const reseBmsTableData = useSelector((state) => state.reseBms.reseBmsTableData);
    const totalRecords = useSelector((state) => state.reseBms.totalRecords);
    const reseBmsTableDanfossVersionsAndFirmware = useSelector((state) => state.reseBms.reseBmsTableDanfossVersionsAndFirmware);
    const reseBmsTableEmersonVersionsAndFirmware = useSelector((state) => state.reseBms.reseBmsTableEmersonVersionsAndFirmware);
    const reseBmsTableStatus = useSelector((state) => state.reseBms.reseBmsTableStatus);
    const toast = useRef(null);
    const updateSuccess = useSelector((state) => state.reseBms.updateSuccess);
    const updateError = useSelector((state) => state.reseBms.updateError);

    const [rowFirmwareValues, setRowFirmwareValues] = useState({});

    const danfossVersionOptions = [...new Set(reseBmsTableDanfossVersionsAndFirmware.map(item => item.version))];

    const emersionVersionOptions = [...new Set(reseBmsTableEmersonVersionsAndFirmware.map(item => item.version))];

    useEffect(() => {
        fetchReseBmsTableData();
        initializeTableFilters();
    }, []);

    useEffect(() => {
        fetchReseBmsTableDanfossVersionandFirmware();
        fetchReseBmsTableEmersonVersionandFirmware();
        fetchReseBmsTableStatus();
    },[])

    useEffect(() => {
        if (updateSuccess) {
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Bms Data updated successfully', life: 3000 });
            fetchReseBmsTableData();
        } else if (updateError) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to update Bms Data', life: 3000 });
        }
    }, [updateSuccess, updateError]); 

    const fetchReseBmsTableData = (params=lazyParams, filters=filterCondition) => {
        const sortDirection= params.sortOrder== -1?'DESC' : 'ASC';
        const filterConditionPayload = constructFilterParams(filters);
        dispatch(getReseBmsTableDataInit(
            params.page,
            params.rows,
            params.sortField,
            sortDirection,
            filterConditionPayload
        ));
    };

    const constructFilterParams = (filterConditions) => {
        if (!filterConditions || typeof filterConditions !== "object") {
          return ""; // Return empty string if no filters are present
        }
        const queryParams = [];
        Object.keys(filterConditions).forEach((key) => {
          const filter = filterConditions[key];
          const constraints = filter?.constraints;
          if (constraints && constraints.length > 0) {
            const { value, matchMode } = constraints[0];
            if (value !== undefined && value !== null && value !== "") {
              queryParams.push(
                `${encodeURIComponent(key)}&${encodeURIComponent(matchMode)}&${encodeURIComponent(value)}`
              );
            }
          }
        });
        return queryParams.join(",");
      };

    const fetchReseBmsTableDanfossVersionandFirmware = () => {
        const brandName = "Danfoss";
        dispatch(getReseBmsTableDanfossVersionFirmwareInit(brandName));
    }

    const fetchReseBmsTableEmersonVersionandFirmware = () => {
        const brandName = "Emerson";
        dispatch(getReseBmsTableEmersonVersionFirmwareInit(brandName));
    }

    const fetchReseBmsTableStatus = () => {
        const statusColumnPayload = {
            targetColumn: "status",
            tableName: "onboard_status"
        }
        dispatch(getReseBmsTableStatusInit(statusColumnPayload))
    };

    const initializeTableFilters = () => {
        setTableFilters({
                    global: {value: null, matchMode: FilterMatchMode.CONTAINS},
                    storeId: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                      },
                      unitId: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                      },
                      brand: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                      },
                      version: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                      },
                      firmware: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                      },
                      ipAddress: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                      },
                      networkSwitch: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                      },
                      networkPort: {
                            operator: FilterOperator.AND,
                            constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },
                    status: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },
                });
    };

    const onPage = (event) => {
        const onPageChangeParams = {
            ...lazyParams,
            first:event.first,
            rows:event.rows,
            page:event.page
        }
        setLazyParams(onPageChangeParams);
        fetchReseBmsTableData(onPageChangeParams);
    }

    const onSort = (event) => {
        const onSortParams = {
            ...lazyParams,
            sortField: event.sortField,
            sortOrder: event.sortOrder
        }
        setLazyParams(onSortParams);
        fetchReseBmsTableData(onSortParams);
    }

    const onFilter = (filters) => {
        setFilterCondition(filters);
        const onFilterParams = {
            ...lazyParams,
            first: 0,
            page: 0
        }
        setLazyParams(onFilterParams);
        fetchReseBmsTableData(onFilterParams,filters);
    }

    const getFirmwares = (brand, version, rowKey) => {
        let firmwares = [];
        if(brand === "Danfoss") {
            const danfossFirmwares = reseBmsTableDanfossVersionsAndFirmware.find(item => item.version === version)
            firmwares = [...new Set(danfossFirmwares?.firmware?.filter(item => item !== null).map(item => item.trim()))] || [];
        }
        else if (brand === "Emerson") {
            const emersionFirmwares = reseBmsTableEmersonVersionsAndFirmware.find(item => item.version === version)
            firmwares = [...new Set(emersionFirmwares?.firmware?.filter(item => item !== null).map(item => item.trim()))] || [];
        }
        setRowFirmwareValues(prev => ({
        ...prev,
        [rowKey]: firmwares
        }));
    }


    const infoBodyTemplate = (rowData) => {
        return <i className='pi pi-info-circle' onClick={() => setInfoDialougeData(rowData)}/>

    }

    const versionEditor = (options) => {
        const brandVersionMap = {
        "Danfoss": danfossVersionOptions,
        "Emerson": emersionVersionOptions
    };
    
    const versionOptions = brandVersionMap[options.rowData.brand] || [];
    
        return <Dropdown value={options.value} options={versionOptions} onChange={(e) => {options.editorCallback(e.value)
            getFirmwares(options.rowData.brand, e.value, options.rowIndex)}} />;
    }

    const firmwareEditor = (options) => {
        const firmwares = rowFirmwareValues[options.rowIndex] || [];
        const currentValue = firmwares.includes(options.value?.trim()) ? options.value?.trim() : firmwares[0];
        options.value = currentValue; // Ensure the value is set to a valid firmware
        options.rowData.firmware = currentValue; // Update the row data with the current value
        return <Dropdown value={options.value?.trim()} options={firmwares} onChange={(e) => options.editorCallback(e.value)} />;
    }

    const statusEditor = (options) => {
        return <Dropdown value={options.value} options={reseBmsTableStatus} onChange={(e) => options.editorCallback(e.value)} />;
    }

    const textEditor = (options) => {
        return <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value)} placeholder='Enter Value'/>
    }

    const numberEditor = (options) => {
        return <InputNumber value={options.value} onChange={(e) => options.editorCallback(e.value)} placeholder='Enter Value'/>
    }

    const onRowEditInit = (e) => {
        getFirmwares(e.data.brand, e.data.version, e.index);
    }

    const onRowEditComplete = (e) => {
        dispatch(updateReseBmsTableDataInit(e.newData));
    }

    return (
        <div className='rese-bms-container container-fluid'>
            <Toast ref={toast} position="bottom-center"/>
            <ReseStoreInfoDialouge dialougeData={infoDialougeData} setDialougeData={setInfoDialougeData}/>
            <p className='page-label'>
            RESE <i className="pi pi-angle-right"/> BMS
            </p>
            <div className='d-flex justify-content-end'>
                <Button 
                className='p-button-text'
                icon='pi pi-refresh'
                onClick={() => fetchReseBmsTableData()}
                />
                <Button
                className='p-button-text'
                icon='pi pi-download'
                onClick={() => reseBmsTableRef.current.exportCSV()}
                />
            </div>
            <DataTable
            value={reseBmsTableData}
            ref={reseBmsTableRef}
            showGridlines
            lazy
            totalRecords={totalRecords}
            filters={tableFilters}
            filterDisplay='menu'
            onFilter={(e) => onFilter(e.filters)}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            onSort={onSort}
            first={lazyParams.first}
            rows={lazyParams.rows}
            rowsPerPageOptions={[10, 20, 50]}
            onPage={onPage}
            editMode='row'
            onRowEditInit= {onRowEditInit}
            onRowEditComplete={onRowEditComplete}
            paginator
            paginatorTemplate='CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink'
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            emptyMessage='No details found'
            >
                <Column field='storeId' header='Store' sortable filter />
                <Column field='unitId' header='Unit' sortable filter />
                <Column field='brand' header='Brand'  sortable filter />
                <Column field='version' header='Version' editor={(options)=>versionEditor(options)} sortable filter />
                <Column field='firmware' header='Firmware' editor={(options)=>firmwareEditor(options)} sortable filter />
                <Column field='ipAddress' header='IP Address' sortable filter />
                <Column field='networkSwitch' header='Network Switch' editor={(options) => textEditor(options)} sortable filter />
                <Column field='networkPort' header='Network Port' editor={(options) => numberEditor(options)} sortable filter />
                <Column field='status' header='Status' editor={(options) => statusEditor(options)} sortable filter />
                <Column header='Info' body={infoBodyTemplate}/>
                <Column rowEditor header='Action' bodyStyle={{minWidth: '7rem'}}/>
            </DataTable>
            
        </div>
    )
};

export default ReseBms;